export default __webpack_public_path__ + "static/media/aladin-dad.4c89728a.gif";